<script>
import FriendsList from "@/components/sections/FriendsList.vue";

export default {
  name: "add-friends",

  components: {
    FriendsList,
  }
}
</script>

<template>
  <div class="v-application add-friends-wrapper">
    <friends-list show-add-friends></friends-list>
  </div>
</template>

<style lang="scss" scoped>
  .add-friends-wrapper {
    background: linear-gradient(180deg, #4a2f70 0%, #6f5b9b 71%) !important;
    padding-top: 30px;
    min-height: 100%;
    height: auto;
  }
</style>

<style lang="scss">
  .v-menu {
    display: block;
  }

  .v-autocomplete__content.menu-container{
    left: 0 !important;
  }
</style>